<div class="card">
    <div class="card-body">
        <div class="card">
            <div class="card-header">
                Multiple Location Geo Mapping
            </div>
            <div class="card-body">
                <div class="row m-1">
                    <div class="col-md-4 px-1">
                        <label class="Label">Branch <span class="text-danger">*</span></label>
                        <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName"
                            bindValue="BranchMasterID" [(ngModel)]="BranchId"
                            (change)=" onSelectChange('Branch'); ComboLoad('Client')" placeholder="Select Branch">
                            <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                                {{ segment.BranchName }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="row m-1">
                    <div class="col-md-8 px-1">
                        <label class="Label">Client <span class="text-danger">*</span></label>
                        <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                            bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                            (change)="onSelectChange('Client'); ComboLoad('Site')" placeholder="Select Client">
                            <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                                {{ segment.ClientGroupName }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="row m-1">
                    <div class="col-md-8 px-1">
                        <label class="Label">Site <span class="text-danger">*</span></label>
                        <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                            [(ngModel)]="SiteId" (change)="onSelectChange('Site');" placeholder="Select Site">
                            <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                                {{ segment.SiteName }}
                            </ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="row m-1">
                    <div class="col-md-4 px-1">
                        <label class="Label">Gate Name <span class="text-danger">*</span></label>
                        <input name="gatename" [(ngModel)]="SiteGateName" type="text" class="form-control"
                            maxlength="100" placeholder="Enter Gate Name" />
                    </div>
                    <div class="col-md-3 px-1">
                        <label class="Label">Latitude</label>
                        <input name="latitude" style="text-align: right;" [(ngModel)]="Latitude" type="number"
                            class="form-control" (keypress)="ValidateInput($event, 'Latitude')"
                            (paste)="onPaste($event)" placeholder="0" />
                    </div>
                    <div class="col-md-3 px-1">
                        <label class="Label">Longitude</label>
                        <input name="longitude" style="text-align: right;" type="number" [(ngModel)]="Longitude"
                            class="form-control" (keypress)="ValidateInput($event, 'Latitude')"
                            (paste)="onPaste($event)" placeholder="0" />
                    </div>
                    <div class="col-md-2 px-1">
                        <label class="Label">Radius</label>
                        <input name="radius" type="number" style="text-align: right;" [(ngModel)]="Radius"
                            class="form-control" (keypress)="ValidateInput($event, 'radius')" min="0"
                            (paste)="onPaste($event)" placeholder="0" />
                    </div>

                </div>
                <div class="row m-1">

                    <div class="col-md-2 px-1">
                        <label class="Label">Altitude</label>
                        <input name="altitude" type="number" style="text-align: right;" [(ngModel)]="Altitude"
                            class="form-control" (keypress)="ValidateInput($event, 'NumandDec')"
                            (paste)="onPaste($event)" placeholder="0" />
                    </div>
                    <div class="col-md-2 px-1">
                        <label class="Label">Altitude Radius</label>
                        <input name="altituderadius" type="number" style="text-align: right;"
                            [(ngModel)]="AltitudeRadius" class="form-control"
                            (keypress)="ValidateInput($event, 'radius')" min="0" (paste)="onPaste($event)"
                            placeholder="0" />
                    </div>

                    <div class="col-md-2 px-1">
                        <label class="Label">Accuracy</label>
                        <input name="accuracy" style="text-align: right;" type="number" [(ngModel)]="Accuracy"
                            class="form-control" (keypress)="ValidateInput($event, 'NumandDec')"
                            (paste)="onPaste($event)" placeholder="0" />
                    </div>
                    <div class="col-md-3 px-1">
                        <label class="Label">Heading</label>
                        <input name="heading" type="number" style="text-align: right;" [(ngModel)]="Heading"
                            class="form-control" (keypress)="ValidateInput($event, 'NumandDec')"
                            (paste)="onPaste($event)" placeholder="0" />
                    </div>

                    <div class="col-auto mt-4">
                        <input class="form-check-input" name="isaltitudeapplicable" id="Active" type="checkbox"
                            [(ngModel)]="IsAltitudeApplicable" value="" />&nbsp;&nbsp;
                        <label class="text-label-dark Label" for="checkbox">
                            Altitude Applicable</label>
                    </div>

                    <div class="col-md-4 px-1"><br>
                        <!-- <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary" name="save" (click)="save()"><i class="bi bi-save"> </i> Save
                        </button>  -->

                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data...
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Action</th>
                                <th scope="col" style="display: none;">ESS_SiteGateGeoMapping ID</th>
                                <th scope="col" style="display: none;">Site Code</th>
                                <th scope="col" style="display: none;">Site ID</th>
                                <th scope="col">Site Name</th>
                                <th scope="col">Site Gate Name</th>
                                <th scope="col">Latitude</th>
                                <th scope="col">Longitude</th>
                                <th scope="col">Radius</th>
                                <th scope="col">IsAltitudeApplicable</th>
                                <th scope="col">Altitude</th>
                                <th scope="col">Altitude Radius</th>
                                <th scope="col">Accuracy</th>
                                <th scope="col">Heading</th>
                                <th scope="col" style="display: none;">IsMocked</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let site of MultipleLocationMapLoad; let i = index">
                                <th scope="row">{{ i + 1 }}</th>
                                <td>
                                    <button class="btn btn-sm btn-group-toggle" style="height: 50%;"
                                        (click)="onEditClick(site)">
                                        <i class="bi bi-pencil-square text-warning"></i>
                                    </button>
                                </td>
                                <td style="display: none;">{{ site['ESS_SiteGateGeoMappingID'] }}</td>
                                <td style="display: none;">{{ site['SiteCode'] }}</td>
                                <td style="display: none;">{{ site['SiteId'] }}</td>
                                <td>{{ site['SiteName'] }}</td>
                                <td>{{ site['SiteGateName'] }}</td>
                                <td>
                                    <div style="width: 120px">
                                        {{ site['Latitude'] }}
                                    </div>
                                </td>
                                <td>
                                    <div style="width: 120px">
                                        {{ site['Longitude'] }}
                                    </div>
                                </td>
                                <td>
                                    <div style="width: 120px">
                                        {{site['Radius']}}
                                    </div>
                                </td>

                                <td style="text-align: center;">
                                    <!-- <input mdbCheckbox class="form-check-input" name="isaltitudeapplicable{{i}}"
                                        style="height: 13px; width: 13px;" type="checkbox"
                                        [(ngModel)]="shift.IsAltitudeApplicable" value="" /> -->
                                    {{site['IsAltitudeApplicable'] == true ? 'Yes' : 'No'}}
                                </td> 

                                <td>
                                    <div style="width: 120px">
                                        {{site['Altitude']}}
                                    </div>
                                </td>
                                <td>
                                    <div style="width: 120px">
                                        {{site['AltitudeRadius']}}
                                    </div>
                                </td>
                                <td>
                                    <div style="width: 120px">
                                        {{site['Accuracy']}}
                                    </div>
                                </td>

                                <td>
                                    <div style="width: 120px">
                                        {{site['Heading']}}
                                    </div>
                                </td>

                                <td style="display: none;">{{ site['IsMocked']}}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                    (click)="exportToExcel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button class="btn btn-sm btn-primary" name="sample" (click)="downloadExcel()">
                    <i class="bi bi-file-earmark-excel-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Sample':'Loading...'}}
                </button>
                &nbsp;&nbsp;
                <label for="file-upload" class="btn btn-sm btn-primary">
                    <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                </label>
                <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                    accept=".xls,.xlsx"> &nbsp;
                <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary" name="save"
                    (click)="save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
                &nbsp;

                <!-- <button class="btn btn-sm btn-primary" name="reset" (click)="reset()"><i
                    class="bi bi-arrow-clockwise"></i> Reset
            </button> -->
                <button class="btn btn-sm btn-primary" name="reset" (click)="reset()">
                    <i class="bi bi-arrow-clockwise" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Reset':'Loading...'}}
                </button>

            </div>
        </div>
    </div>
</div>